module.exports = __webpack_public_path__ + "static/media/Group 5915.084b929c.svg";